import { render, staticRenderFns } from "./openstreemap2.vue?vue&type=template&id=30898400&"
import script from "./openstreemap2.vue?vue&type=script&lang=js&"
export * from "./openstreemap2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30898400')) {
      api.createRecord('30898400', component.options)
    } else {
      api.reload('30898400', component.options)
    }
    module.hot.accept("./openstreemap2.vue?vue&type=template&id=30898400&", function () {
      api.rerender('30898400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2drp50WKJzEMO/JS/comp/openstreemap2.vue"
export default component.exports